<template>
  <path
    d="M12.4774 2C7.49802 2 3.4137 5.82102 3 10.6855H13.8163L10.7625 7.45002C10.439 7.14974 10.4315 6.5642 10.7549 6.26393C11.0859 5.95614 11.65 6.06875 11.9434 6.33149L16.2835 10.9407C16.4188 11.0834 16.4941 11.3086 16.5016 11.4962C16.5016 11.7139 16.4264 11.8941 16.2835 12.0518L11.9434 16.661C11.6576 16.9388 11.0784 17.0363 10.7549 16.7286C10.4315 16.4283 10.4842 15.8202 10.7625 15.5425L13.8163 12.307H3C3.4137 17.1715 7.49802 21 12.4774 21C17.7352 21 22 16.7436 22 11.4962C22 6.24891 17.7352 2 12.4774 2Z"
  />
</template>
